 import React from "react";
//  import arrow from "../assets/arrow-white.png" ;
 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight} from '@fortawesome/free-solid-svg-icons';



 const DestinationCard =(props)=> {

    return(
        <>
        <div className="destination-container">
        <div>
        <img className='destination-image' src={props.img} alt="destinations" ></img>
        </div>
        <p>{props.name}</p>
        <button>Sail Now <FontAwesomeIcon icon={ faArrowRight} style={{color:"#164D55"}} /></button>
        </div>
          

        </>
    );
 }


 export default DestinationCard ;